/**
 * Portal ICAVI - Serviço de domínio: Gestão de Carros
 * Extraído de apiService.ts para reduzir o tamanho do módulo monolítico (RF-07).
 */
import axios from 'axios';
import { api } from '../apiClient';
export const carrosServiceMethods = {
    async listarCarros() {
        try {
            const response = await api.get('/api/carros/listar');
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar carros:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async listarCarrosComColaboradores(forceRefresh = false) {
        try {
            let url = '/api/carros/listar-com-colaboradores';
            const headers = {};
            if (forceRefresh) {
                url += `?_t=${Date.now()}`;
                headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
                headers['Pragma'] = 'no-cache';
                headers['Expires'] = '0';
            }
            const response = await api.get(url, { headers });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar carros com colaboradores:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async adicionarCarro(dados) {
        try {
            const response = await api.post('/api/carros/adicionar', dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao adicionar carro:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async atualizarCarro(carroId, dados) {
        try {
            const response = await api.put(`/api/carros/atualizar/${carroId}`, dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao atualizar carro:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async excluirCarro(carroId) {
        try {
            const response = await api.delete(`/api/carros/excluir/${carroId}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao excluir carro:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async listarColaboradoresCarros(dataCadastro = null, forceRefresh = false, dataInicio = null, dataFim = null) {
        try {
            let url = '/api/carros/colaboradores';
            const params = [];
            if (dataInicio && dataFim) {
                params.push(`data_inicio=${dataInicio}`);
                params.push(`data_fim=${dataFim}`);
            }
            else if (dataCadastro) {
                params.push(`data_cadastro=${dataCadastro}`);
            }
            if (forceRefresh) {
                params.push(`_t=${Date.now()}`);
            }
            if (params.length > 0) {
                url += `?${params.join('&')}`;
            }
            const headers = {};
            if (forceRefresh) {
                headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
                headers['Pragma'] = 'no-cache';
                headers['Expires'] = '0';
            }
            const response = await api.get(url, { headers });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar colaboradores para carros:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async atribuirCarro(dados) {
        try {
            const response = await api.post('/api/carros/atribuir', dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao atribuir carro:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async atribuirCarroLote(dados) {
        try {
            const response = await api.post('/api/carros/atribuir-lote', dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao atribuir carro em lote:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async liberarCarro(dados) {
        try {
            const response = await api.post('/api/carros/liberar', dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao liberar carro:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async removerColaboradorCarro(dados) {
        try {
            const response = await api.post('/api/carros/remover-colaborador', dados, {
                timeout: 30000,
            });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao remover colaborador do carro:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async marcarColaboradorIndisponivel(dados) {
        try {
            const response = await api.post('/api/carros/colaboradores/marcar-indisponivel', dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao marcar colaborador como indisponível:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async marcarColaboradoresIndisponivelLote(dados) {
        try {
            const response = await api.post('/api/carros/colaboradores/marcar-indisponivel-lote', dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao marcar colaboradores como sem carro em lote:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async definirMotorista(data) {
        try {
            const response = await api.post('/api/carros/definir-motorista', data);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao definir motorista:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async liberarCarrosAutomatico(data = {}) {
        try {
            const response = await api.post('/api/carros/liberar-automatico', data);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao liberar carros automaticamente:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async limparAtribuicoesCarros(data = {}) {
        try {
            const response = await api.post('/api/carros/limpar-atribuicoes', data);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao limpar atribuições de carros:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async obterMotoristasPorData(forceRefresh = false) {
        try {
            let url = '/api/carros/motoristas-por-data';
            const headers = {};
            if (forceRefresh) {
                url += `?_t=${Date.now()}`;
                headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
                headers['Pragma'] = 'no-cache';
                headers['Expires'] = '0';
            }
            const response = await api.get(url, { headers });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao obter motoristas por data:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async limparMotoristasAntigos(dados = {}) {
        try {
            const response = await api.post('/api/carros/limpar-motoristas-antigos', dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao limpar motoristas antigos:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async verificarMotoristasInconsistentes() {
        try {
            const response = await api.get('/api/carros/verificar-motoristas-inconsistentes');
            return response.data;
        }
        catch (error) {
            console.error('Erro ao verificar motoristas inconsistentes:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async obterUtilizacaoRealCarros(filtros = {}) {
        try {
            const params = new URLSearchParams();
            if (filtros.carro_id)
                params.append('carro_id', filtros.carro_id.toString());
            if (filtros.data_inicio)
                params.append('data_inicio', filtros.data_inicio);
            if (filtros.data_fim)
                params.append('data_fim', filtros.data_fim);
            if (filtros.colaborador_nome)
                params.append('colaborador_nome', filtros.colaborador_nome);
            if (filtros.setor)
                params.append('setor', filtros.setor);
            if (filtros.limite)
                params.append('limite', filtros.limite.toString());
            const url = params.toString()
                ? `/api/carros/utilizacao-real?${params}`
                : '/api/carros/utilizacao-real';
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao obter utilização real de carros:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async obterHistoricoDetalhadoVeiculos(filtros = {}) {
        try {
            const params = new URLSearchParams();
            if (filtros.carro_id)
                params.append('carro_id', filtros.carro_id.toString());
            if (filtros.data_inicio)
                params.append('data_inicio', filtros.data_inicio);
            if (filtros.data_fim)
                params.append('data_fim', filtros.data_fim);
            if (filtros.limite)
                params.append('limite', filtros.limite.toString());
            const url = params.toString()
                ? `/api/carros/historico/detalhado?${params}`
                : '/api/carros/historico/detalhado';
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao obter histórico detalhado de veículos:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async getHistoricoMotoristas(filtros = {}) {
        try {
            const params = new URLSearchParams();
            if (filtros.carro_id)
                params.append('carro_id', filtros.carro_id.toString());
            if (filtros.data_inicio)
                params.append('data_inicio', filtros.data_inicio);
            if (filtros.data_fim)
                params.append('data_fim', filtros.data_fim);
            if (filtros.limite)
                params.append('limite', filtros.limite.toString());
            const url = params.toString()
                ? `/api/carros/historico/motoristas?${params}`
                : '/api/carros/historico/motoristas';
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao obter histórico de motoristas:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async listarCidadesCarros(forceRefresh = false) {
        try {
            let url = '/api/carros/cidades';
            if (forceRefresh)
                url += `?_t=${Date.now()}`;
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar cidades para carros:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async listarPontosEmbarque(forceRefresh = false) {
        try {
            let url = '/api/carros/pontos-embarque';
            if (forceRefresh)
                url += `?_t=${Date.now()}`;
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar pontos de embarque:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async obterDadosExportacaoDistribuicao(filtros = {}) {
        try {
            const params = new URLSearchParams();
            if (filtros.data_cadastro)
                params.append('data_cadastro', filtros.data_cadastro);
            if (filtros.data_inicio)
                params.append('data_inicio', filtros.data_inicio);
            if (filtros.data_fim)
                params.append('data_fim', filtros.data_fim);
            if (filtros.cidade)
                params.append('cidade', filtros.cidade);
            if (filtros.ponto_embarque)
                params.append('ponto_embarque', filtros.ponto_embarque);
            if (filtros.carro_id)
                params.append('carro_id', filtros.carro_id.toString());
            if (typeof filtros.apenas_hora_extra !== 'undefined' && filtros.apenas_hora_extra !== null) {
                const val = filtros.apenas_hora_extra === true || filtros.apenas_hora_extra === 'true';
                params.append('apenas_hora_extra', val ? 'true' : 'false');
            }
            if (typeof filtros.incluir_motoristas !== 'undefined' && filtros.incluir_motoristas !== null) {
                const val = filtros.incluir_motoristas === true || filtros.incluir_motoristas === 'true';
                params.append('incluir_motoristas', val ? 'true' : 'false');
            }
            const url = params.toString()
                ? `/api/carros/exportacao/distribuicao?${params}`
                : '/api/carros/exportacao/distribuicao';
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao obter dados de exportação:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
};
